import { render, staticRenderFns } from "./AllowancesPlanDetailsTable.vue?vue&type=template&id=cbe21738&"
import script from "./AllowancesPlanDetailsTable.vue?vue&type=script&lang=js&"
export * from "./AllowancesPlanDetailsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports